import React from "react";
import { ACTIONS } from "../state/contexts/quizState";
import { useQuiz } from "../services/hooks/useQuiz";

export default React.memo(function QuizQ13({ isActive }) {
  const { setAnswer, quizResponses } = useQuiz();

  const { ethnicity } = quizResponses;

  const onAnswer = (answer) => {
    setAnswer(ACTIONS.SET_ETHNICITY, {
      ethnicity: answer,
    });
  };

  const options = [
    {
      title: "Asian",
    },
    {
      title: "Black / African-American",
    },
    {
      title: "White or Caucasian",
    },
    {
      title: "Hispanic / Latino",
    },
    {
      title: "South Asian",
    },
    {
      title: "Other race, ethnicity, or ancestry",
    },
  ];

  const listItems = options.map(({ title }) => (
    <div
      key={title}
      className="quiz-radio-option"
      onClick={() => onAnswer(title)}
    >
      <div className="custom-control custom-radio float-left">
        <input
          type="radio"
          id={title}
          name="ethnicity"
          value={title}
          className="custom-control-input"
          checked={ethnicity === title}
          onChange={(e) => {
            onAnswer(e.target.value);
          }}
        />
        <label className="custom-control-label" htmlFor={title}></label>
      </div>
      <div className="ml-8 quiz-radio-content">
        <p className="font-size-h6">{title}</p>
      </div>
    </div>
  ));

  if (!isActive) {
    return null;
  }

  return (
    <React.Fragment>
      <h4 className="mb-8">How would you best describe your ethnicity?</h4>

      <div className="quiz-radio-options">{listItems}</div>
    </React.Fragment>
  );
});
